import { render, staticRenderFns } from "./VoiceMessage.vue?vue&type=template&id=027af3ae&scoped=true"
import script from "./VoiceMessage.vue?vue&type=script&lang=js"
export * from "./VoiceMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027af3ae",
  null
  
)

export default component.exports